<template>
  <div
    v-touch.long="() => emit('long-press')"
    class="group relative flex cursor-pointer items-center rounded-8 p-1 hover:bg-bg-base-bg3 active:bg-surf-neut-soft-pres"
    :data-gallery-media-anchor="!showKebab ? anchorId : undefined"
    data-test="chat-gallery-link-item"
    @click="emit('open')"
    @contextmenu.prevent="emit('contextmenu', $event)"
  >
    <div class="flex min-w-0 flex-1 flex-col gap-0.5 py-0.5 pl-2">
      <p
        class="truncate text-body-r-14-20 text-comp-link-neut-def"
        :title="title"
      >
        {{ title }}
      </p>
      <p
        v-if="subtitle"
        class="truncate text-label-r-13-18 text-fg-base-fg22"
      >
        {{ subtitle }}
      </p>
    </div>

    <div
      v-if="showKebab"
      class="ml-1 hidden shrink-0 group-hover:block"
      :class="{ '!block': isMenuActive }"
    >
      <wui-btn
        icon
        variant="neut"
        state="alpha"
        :size="32"
        prepend-icon="kebabVerticalM"
        class="text-fg-base-fg1!"
        :data-gallery-media-anchor="anchorId"
        data-test="chat-gallery-link-menu"
        :aria-label="$t('common.more')"
        @click.stop="emit('open-menu', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiBtn } from '@wui/common-library'

import { vTouch } from '@/shared/directives/v-touch'

withDefaults(defineProps<{
  title: string
  subtitle?: string
  showKebab?: boolean
  isMenuActive?: boolean
  anchorId?: string
}>(), {
  subtitle: '',
  showKebab: false,
  isMenuActive: false,
  anchorId: '',
})

const emit = defineEmits<{
  (event: 'open'): void
  (event: 'open-menu', mouseEvent: Event): void
  (event: 'contextmenu', mouseEvent: MouseEvent): void
  (event: 'long-press'): void
}>()
</script>
